
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Link2, Copy, CheckCheck } from "lucide-react";
import { useToast } from "@/components/ui/use-toast";

type ServiceLinkProps = {
  getFullUrl: () => string;
  isMobile: boolean;
};

export const ServiceLink: React.FC<ServiceLinkProps> = ({ getFullUrl, isMobile }) => {
  const { toast } = useToast();
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    try {
      const fullUrl = getFullUrl();
      await navigator.clipboard.writeText(fullUrl);
      setCopied(true);
      toast({
        title: "Link copied!",
        description: "The service link has been copied to your clipboard.",
      });
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast({
        title: "Failed to copy",
        description: "Please try copying the link manually.",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-6 mb-8 hover:shadow-lg transition-shadow duration-200">
      <div className="flex items-center gap-3 mb-4">
        <Link2 className="w-6 h-6 text-gebeya-pink" />
        <h2 className="text-lg font-semibold">Your Service Link</h2>
      </div>
      
      <div className={isMobile ? "flex flex-col gap-2" : "flex gap-2 items-center"}>
        <input
          type="text"
          value={getFullUrl()}
          readOnly
          className="flex-1 p-3 bg-gray-50 rounded-lg text-gray-700 font-medium text-sm sm:text-base w-full truncate"
        />
        <Button
          onClick={copyToClipboard}
          variant="outline"
          className={`flex gap-2 items-center justify-center hover:bg-gray-50 ${isMobile ? "w-full mt-2" : "min-w-[90px]"}`}
        >
          {copied ? (
            <CheckCheck className="w-4 h-4 text-green-500" />
          ) : (
            <Copy className="w-4 h-4" />
          )}
          Copy
        </Button>
      </div>
    </div>
  );
};
